import React from 'react';

import { Footer, Header, ScrollTop, ScrollToTop } from './components';
import { HomePage, ContactUs, AboutUs, TeamPage, TestimonialsPage, BlogGrid, BlogList, BlogSingle, ShopGrid, ShopList, ProductSingle, Wishlist, Checkout, Cart, Login, Register, ForgotPwd, ChangePwd, Profile, EditProfile, EditAddress, MenuPage, Reservation, OrderConfirmation, ClientPage, TeamSingle, ServicePage, ServiceSingle, FaqPage, GalleryPage } from './sections';

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from 'react-toastify';



const App = () => {
  return (
    <div className='App'>

      {/* Component to Scroll to Top on Route Change */}
      <ScrollToTop />

      {/* Render the header component */}
      <Header />

      <Routes>

        {/*Home*/}
        <Route path='/' element={<HomePage />} />

        {/*About*/}
        <Route path='/About-us' element={<AboutUs />} />
        <Route path='/Team' element={<TeamPage />} />  
        <Route path='/Team/:id' element={<TeamSingle />} />    
        <Route path='/Team/Team-Single' element={<TeamSingle />} /> 
        <Route path='/Testimonials' element={<TestimonialsPage />} /> 
        <Route path='/Faqs' element={<FaqPage />} />

        {/*Menu*/}
        <Route path='/Menu' element={<MenuPage />} /> 

        {/*Pages*/}
        <Route path='/Gallery' element={<GalleryPage />} /> 
        <Route path='/Reservation' element={<Reservation />} /> 
        <Route path='/Clients' element={<ClientPage />} /> 
        <Route path='/Login' element={<Login />} />  
        <Route path='/Register' element={<Register />} /> 
        <Route path='/Forgot-Password' element={<ForgotPwd />} /> 
        <Route path='/Change-Password' element={<ChangePwd />} /> 
        <Route path='/Profile' element={<Profile />} /> 
        <Route path='/Edit-Profile' element={<EditProfile />} />  
        <Route path='/Edit-Address' element={<EditAddress />} /> 

        {/*Services*/}
        <Route path='/Services' element={<ServicePage />} />
        <Route path='/Services/:id' element={<ServiceSingle />} />
        <Route path='/Services/Service-Single' element={<ServiceSingle />} /> 

        {/*Blogs*/}
        <Route path='/Blog-grid' element={<BlogGrid />} /> 
        <Route path='/Blogs/category/:category' element={<BlogList />} /> 
        <Route path='/Blogs/tag/:tag' element={<BlogList />} /> 
        <Route path='/Blogs/search/:search' element={<BlogList />} /> 
        <Route path='/Blog-list' element={<BlogList />} /> 
        <Route path='/Blogs/:id' element={<BlogSingle  />} />
        <Route path='/Blogs/Blog-Single' element={<BlogSingle />} />

        {/*Shop*/}
        <Route path='/Shop-grid' element={<ShopGrid />} />  
        <Route path='/Shop/category/:category' element={<ShopList />} /> 
        <Route path='/Shop/tag/:tag' element={<ShopList />} /> 
        <Route path='/Shop/search/:search' element={<ShopList />} /> 
        <Route path='/Shop-list' element={<ShopList />} />
        <Route path='/Shop/:id' element={<ProductSingle />} />
        <Route path='/Shop/Product-Single' element={<ProductSingle />} /> 
        <Route path='/Wishlist' element={<Wishlist />} />
        <Route path='/Cart' element={<Cart />} />
        <Route path='/Checkout' element={<Checkout />} />
        <Route path='/OrderConfirmation' element={<OrderConfirmation />} />
 
        {/*Contact*/}
        <Route path='/Contact-Us' element={<ContactUs />} />

      </Routes>

      {/* Render the footer component */}
      <Footer />

      {/* Scroll to top button */}
      <ScrollTop />
      <ToastContainer />

    </div>
  )
}

export default App;
